import { callBackendApi } from "../../../../../../components/service/axios";

export async function getReviewHistory(appId) {
  return await callBackendApi("get", `bff/applications/${appId}/review-history`);
}

export async function sendReminderEmail(appId) {
  return await callBackendApi("post", `bff/apps/${appId}/send-reminder-email`);
}
